export default __webpack_public_path__ + "static/pointOne-e519b1237972d4e79e3cc1682fba9c6b.png";